/*
 * ============================================================
 * SELLER STORE PAGE — assets/ccs-storefront.js
 * ============================================================
 * The category tabs on a seller's shop front, and the order underneath them.
 *
 * The grid is already on the page, complete and in the collection's own
 * order, rendered by sections/ccs-store-grid.liquid. This adds the tabs the
 * seller made and puts their designs in the order they arranged them.
 *
 * ── Everything here is an enhancement ──────────────────────────────────────
 * If this script never runs, or the request fails, the shopper is left with
 * a complete working grid. So nothing starts hidden waiting to be shown, and
 * every failure path is "leave the page as it is" rather than "show an
 * error" -- a shop that quietly loses its tabs still sells shirts; one that
 * hides its products does not.
 *
 * ── Why the cards are not rendered here ────────────────────────────────────
 * They are rendered by Liquid, from the products themselves. A price drawn
 * from the marketplace API could disagree with the one the cart charges;
 * a price drawn from the product cannot. The API supplies the tabs and the
 * order, and nothing else.
 */
(function (window, document) {
  'use strict';

  var root = document.getElementById('ccs-store');
  if (!root || !window.CCSApi) return;

  var handle = root.getAttribute('data-handle') || '';
  var grid = root.querySelector('[data-ccs="grid"]');
  var tabs = root.querySelector('[data-ccs="tabs"]');
  var empty = root.querySelector('[data-ccs="empty"]');
  if (!handle || !grid || !tabs) return;

  var data = null;
  // null is All items, throughout. Not a string, so there is no magic value
  // that a real category uid could ever collide with.
  var active = null;

  var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-handle]'));
  var byHandle = {};
  cards.forEach(function (card) { byHandle[card.getAttribute('data-handle')] = card; });

  /*
   * A CCS product's handle IS its listing uid -- publishListing gives it that
   * handle on purpose -- so the ordered uid lists the API returns can be
   * matched against the rendered cards without a second lookup.
   */
  function cardFor(uid) { return byHandle[uid] || null; }

  function apply() {
    var order = active
      ? ((find(active) || {}).listingUids || [])
      : (data.allItemsOrder || []);

    var shown = 0;
    // Re-appended in order. Moving a node that is already in the right place
    // is a no-op to the browser, so this is cheaper than it looks and avoids
    // having to work out what actually changed.
    order.forEach(function (uid) {
      var card = cardFor(uid);
      if (!card) return;
      card.hidden = false;
      grid.appendChild(card);
      shown += 1;
    });

    // Anything the order did not mention. On a category that is everything
    // not in it; on All items it should be nothing, but a design published a
    // moment ago can beat the API's view of the store, and the right answer
    // for a product that exists is to show it.
    cards.forEach(function (card) {
      if (order.indexOf(card.getAttribute('data-handle')) > -1) return;
      if (active) { card.hidden = true; return; }
      card.hidden = false;
      grid.appendChild(card);
      shown += 1;
    });

    if (empty) empty.hidden = shown > 0;
  }

  function find(uid) {
    return (data.categories || []).filter(function (c) { return c.uid === uid; })[0] || null;
  }

  function renderTabs() {
    tabs.textContent = '';

    var list = [{ uid: null, name: 'All items' }].concat(
      (data.categories || []).map(function (c) { return { uid: c.uid, name: c.name }; }));

    list.forEach(function (tab) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'ccs-tab' + (tab.uid === active ? ' is-active' : '');
      button.textContent = tab.name;
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-selected', tab.uid === active ? 'true' : 'false');
      button.addEventListener('click', function () {
        active = tab.uid;
        renderTabs();
        apply();
        // The chosen tab survives a reload and a shared link. Written rather
        // than navigated, so choosing one does not stack history entries a
        // shopper then has to press Back through to leave the shop.
        var url = tab.uid
          ? location.pathname + '?cat=' + encodeURIComponent(tab.uid)
          : location.pathname;
        try { history.replaceState(null, '', url); } catch (e) {}
      });
      tabs.appendChild(button);
    });

    tabs.hidden = false;
  }

  function chosenFromUrl() {
    var match = location.search.match(/[?&]cat=([^&]*)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  window.CCSApi.getStorefront(handle).then(function (payload) {
    data = payload;

    /*
     * Tabs and order are two different things, and only the tabs depend on
     * the seller having made categories.
     *
     * A seller with no categories leaves no trace of the feature on their
     * page: a shopper offered a single "All items" tab is looking at
     * something broken, not at a feature going unused. But they can still
     * arrange their designs, and that arrangement is the whole point of the
     * order below -- so returning here, as this did, meant dragging cards in
     * the dashboard changed nothing a shopper ever saw.
     */
    if (data.show) {
      // A link to a particular tab wins over the seller's default: somebody
      // followed it on purpose. A stale uid falls through to All items rather
      // than to an empty page.
      var wanted = chosenFromUrl();
      if (wanted && find(wanted)) active = wanted;
      else if (data.defaultCategoryUid && find(data.defaultCategoryUid)) active = data.defaultCategoryUid;

      renderTabs();
    }

    apply();
  }).catch(function (error) {
    // The grid is already complete and in the collection's order. Losing the
    // tabs is a worse shop; hiding the products is no shop at all.
    if (window.console && console.warn) {
      console.warn('[ccs] categories unavailable', error);
    }
  });
})(window, document);
